<template>
  <div class="mx-auto">
    <div class="text-center py-5">
      <div class="text-2xl font-bold text-white">
        Cosa vorresti
        sostenere a Natale?
      </div>
      <div class="text-accent font-thin">
        Dona un aiuto a una causa per te importante
      </div>
    </div>
    <div v-if="activeSlide">
      <Splide :options="sliderOptions" aria-label="Cause sociali">
        <SplideSlide :key="action" v-for="action in actions" class="text-center gap-3">

          <div class="card card-compact w-48" @click="navigateTo(`/cause-sociali/${action.slug}`)">
            <figure class=" shadow-xl">
              <img :src="CDN_URL+action.image" class="rounded-3xl" :alt="action.label">
            </figure>

            <div class="text-wrap font-thin">
              {{ action.label }}
            </div>
          </div>
        </SplideSlide>
      </Splide>
    </div>
    <div v-else>
      <div class="flex flex-wrap justify-center gap-3">
        <div :key="action" v-for="action in actions" class="text-center">

          <div class="card card-compact w-48" @click="navigateTo(`/cause-sociali/${action.slug}`)">
            <figure class=" shadow-xl">
              <img :src="CDN_URL+action.image" class="rounded-3xl" :alt="action.label">
            </figure>

            <div class="text-wrap font-thin">
              {{ action.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import actions from "assets/models/causes.json";
import {useMediaQuery} from "@vueuse/core";
import '@splidejs/vue-splide/css';
import {onMounted} from "vue";
const isLargeScreen = useMediaQuery('(min-width: 1600px)')
const activeSlide = ref(false);
onMounted(() => {
  activeSlide.value = !isLargeScreen.value;
  watch(()=>isLargeScreen, () => {
    activeSlide.value = !isLargeScreen.value;
  },{deep:true})
})

const {public: {CDN_URL}} = useRuntimeConfig();

const sliderOptions = ref({
  type:'loop',
  pagination: false,
  rewind: false,
  perPage: 4,
  loop: false,
  autoHeight: true,
  autoWidth: true,
  arrows:false,
  gap: '1rem',
  perMove: 1,
  breakpoints: {
    perPage: 4,
    breakpoints: {
      1280: {
      },
      640: {
        perPage: 2,
      },
    }
  }
})
</script>


<style scoped lang="scss">
figure {
  cursor: pointer;
}
</style>